import moment from 'moment';
import React, { useState } from 'react';
import { Icon, Modal } from 'semantic-ui-react';
import { RangePicker } from 'react-minimal-datetime-range';
import { ScheduleInterview } from '../../../../services/apiService';
import { styledDefaultColDef } from '../../../../extras/cellRenderers';
import { getFullName } from '../../../../utils';

function StudentsGetter(params) {
  return (
    <div className='relative flex items-center text-center top-2'>
      <div className='ml-2 text-center'>
        <span>{getFullName(params.data?.userDetails ?? {})}</span>
      </div>
    </div>
  );
}

function CompanyGetter(params) {
  return (
    <div className='relative flex items-center text-center top-2'>
      <div className='ml-2 text-center'>
        <span>{params?.data?.companyDetails?.companyName ?? ''}</span>
      </div>
    </div>
  );
}

function InterviewDateGetter(params) {
  return (
    <div className='relative flex items-center top-1'>
      {params?.data?.startTime
        ? `${moment(params?.data?.startTime).format('DD MMM YYYY')}`
        : ''}
    </div>
  );
}

function InterviewTimeGetter(params) {
  const [showModal, setShowModal] = useState(false);
  let startDate = null;
  let endDate = null;

  const handleDateChange = (range) => {
    console.log('set range:', range);
    startDate = range[0];
    endDate = range[1];
  };

  const clearDates = () => {
    startDate = null;
    endDate = null;
  };
  // invoke schedule interview api
  const handleInterviewSchedule = async (roundId) => {
    try {
      if (startDate && endDate && roundId) {
        const response = await ScheduleInterview({
          roundId: roundId,
          startTime: startDate,
          endTime: endDate,
        });
        if (response) params?.onChangeHandler({ startDate, endDate });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderTimeCell = () => {
    if (
      params?.data?.status === 'unscheduled' ||
      (!params?.data?.startTime && !params?.data?.endTime)
    ) {
      return (
        <button
          onClick={() => {
            setShowModal(true);
          }}
          className='px-3 py-1 text-base font-medium border-solid rounded bg-pastel-red text-brand-primary border-brand-primary'
        >
          <Icon name='calendar alternate outline' size='small' />
          <span className='text-xs font-semibold '> Add Timmings </span>
        </button>
      );
    } else {
      return (
        <div
          className='relative flex items-center text-left top-2'
          onClick={() => {
            setShowModal(true);
          }}
        >
          <div className='flex-col whitespace-normal '>
            <div
              className='text-sm font-semibold'
              style={{ whiteSpace: 'wrap' }}
            >
              <Icon name='calendar alternate outline' size='small' />
              {params?.data?.startTime
                ? `${moment(params?.data?.startTime).format('h:mm a')}`
                : ''}

              {' to '}
              {params?.data?.endTime
                ? `${moment(params?.data?.endTime).format('h:mm a')}`
                : ''}
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className='relative flex items-center top-2'>
      {params?.data?.status && renderTimeCell()}
      <Modal
        onClose={() => setShowModal(false)}
        onOpen={() => setShowModal(true)}
        open={showModal}
      >
        <Modal.Header>{`Schedule Round ${
          params?.data?.roundNumber
        } for ${getFullName(params.data?.userDetails ?? {})}`}</Modal.Header>
        <Modal.Content>
          <RangePicker
            locale='en-us'
            show={true}
            disabled={false}
            placeholder={['Start Time', 'End Time']}
            defaultDates={[
              `${
                moment(params?.data?.startTime)
                  .utc()
                  .format('YYYY-MM-DD,hh:mm:ss') ?? 'YYYY-MM-DD'
              }`,
              `${
                moment(params?.data?.endTime)
                  .utc()
                  .format('YYYY-MM-DD, hh:mm:ss') ?? 'YYYY-MM-DD'
              }`,
            ]}
            // defaultTimes={['hh:mm', 'hh:mm']}
            initialDates={[
              `${
                moment(params?.data?.startTime)
                  .utc()
                  .format('YYYY-MM-DD,hh:mm:ss') ?? 'YYYY-MM-DD'
              }`,
              `${
                moment(params?.data?.endTime)
                  .utc()
                  .format('YYYY-MM-DD, hh:mm:ss') ?? 'YYYY-MM-DD'
              }`,
            ]} // ['YYYY-MM-DD', 'YYYY-MM-DD']
            onConfirm={(res) => handleDateChange(res)}
            onClose={() => console.log('onClose')}
            onClear={() => clearDates()}
            style={{ width: '600px', margin: '0 auto' }}
          />
        </Modal.Content>
        <Modal.Actions>
          <button
            onClick={() => {
              setShowModal(false);
            }}
            className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
          >
            Cancel
          </button>
          <button
            onClick={() => {
              setShowModal(false);
              handleInterviewSchedule(params?.data?.roundId);
            }}
            className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
          >
            Schedule
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

// function StatusGetter(params) {
//   return (
//     <div className='relative flex items-center top-1'>
//       <span
//         className='px-2 py-1 font-semibold text-center rounded '
//         style={{
//           width: '100px',
//         }}
//       >
//         {params.data?.status}
//       </span>
//     </div>
//   );
// }
function JobRoleGetter(params) {
  return (
    <div className='relative flex items-center top-1'>
      <span className='px-2 py-1 text-center rounded'>
        {params.data?.jobTitleDetails?.title}
      </span>
    </div>
  );
}

function SpockGetter(params) {
  return (
    <div className='flex items-center justify-end'>
      <span>{getFullName(params.data?.placementSpocDetails ?? {})}</span>
    </div>
  );
}

export const columnDefs = [
  {
    headerName: 'Date and day',
    field: 'startTime',
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: InterviewDateGetter,
    filter: 'agDateColumnFilter',
    filterParams: {
      valueGetter: (props) => moment(props.data?.startTime),
      debounceMs: 200,
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = moment(cellValue).format('DD/MM/YYYY');
        if (dateAsString == null) {
          return 0;
        }
        const dateParts = dateAsString.split('/');
        const year = Number(dateParts[2]);
        const month = Number(dateParts[1]) - 1;
        const day = Number(dateParts[0]);
        const cellDate = new Date(year, month, day);

        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        } else if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const dateA = moment(nodeA.data?.startDate);
      const dateB = moment(nodeB.data?.startDate);
      const comparison = dateA.diff(dateB);
      return comparison;
    },
  },
  {
    headerName: 'Time',
    field: 'time',
    cellRenderer: InterviewTimeGetter,
  },
  {
    headerName: 'Student',
    field: 'student',
    cellRenderer: StudentsGetter,
  },
  {
    headerName: 'Company',
    field: 'student',
    cellRenderer: CompanyGetter,
  },
  {
    headerName: 'Job Role',
    field: 'jobRole',
    cellRenderer: JobRoleGetter,
  },
  // {
  //   headerName: 'Status',
  //   field: 'status',
  //   cellRenderer: StatusGetter,
  // },
  // {
  //   headerName: 'Actions',
  //   field: 'actions',
  //   cellRenderer: 'btnCellRenderer',
  //   sortable: false,
  //   suppressMenu: true,
  // },
  {
    headerName: 'Placement Spoc',
    field: 'placementSpock',
    resizable: true,
    cellRenderer: SpockGetter,
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
